/**
 * @generated SignedSource<<4efa12f7f541841dab64547abfc21058>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTilePrice_etherRates$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
  readonly " $fragmentType": "NftItemTilePrice_etherRates";
}>;
export type NftItemTilePrice_etherRates$key = ReadonlyArray<{
  readonly " $data"?: NftItemTilePrice_etherRates$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTilePrice_etherRates">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NftItemTilePrice_etherRates",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEtherConversion_etherRates"
    }
  ],
  "type": "EtherRates",
  "abstractKey": null
};

(node as any).hash = "14e094d2c5d5996c851851972273b52f";

export default node;
